<template>
  <div :class="timerColor">{{minutes}}m {{seconds}}s</div>
</template>

<script>
export default {
  data () {
    return {
      elapsedTime: '',
      date: new Date(this.time),
      minutes: 0,
      seconds: 0,
      interval: null,
      intervals: {
        second: 1000,
        minute: 1000 * 60,
        hour: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24
      },
      timerColor: 'text-green-darker'
    }
  },
  props: ['time', 'timerClass'],
  emits: ['update:timerClass'],
  mounted () {
    this.interval = setInterval(() => {
      this.updatedTime()
    }, 1000)

    this.updatedTime()
    if (this.minutes >= 10 && this.minutes < 15) {
      this.timerColor = 'text-yellow-darker'
    } else if (this.minutes >= 15) {
      this.timerColor = 'text-red-dark'
    }
  },
  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    updatedTime () {
      let diff = Math.abs(Date.now() - this.date.getTime())
      this.days = Math.floor(diff / this.intervals.day)
      diff -= this.days * this.intervals.day
      this.hours = Math.floor(diff / this.intervals.hour)
      diff -= this.hours * this.intervals.hour
      this.minutes = Math.floor(diff / this.intervals.minute)
      diff -= this.minutes * this.intervals.minute
      this.seconds = Math.floor(diff / this.intervals.second)

      if (this.minutes === 10 && this.seconds === 0) {
        this.timerColor = 'text-yellow-darker'
      } else if (this.minutes === 15 && this.seconds === 0) {
        this.timerColor = 'text-red-dark'
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Consultations/TimeElapsed.vue